export const buildSubscriptionBenefits = (numClicks) => [
  `${numClicks.toLocaleString()} ad clicks per month`,
  'Monitor unlimited websites',
  'Detect click fraud',
  'Prevent click fraud',
  'Re-train ad networks',
  'Dedicated account manager',
];

export const buildSharedSubscriptionBenefits = () => [
  'Monitor unlimited websites',
  'Detect click fraud',
  'Prevent click fraud',
  'Re-train ad networks',
  'Dedicated account manager',
];

export const formatBillingDate = (date) => {
  const d = new Date(date);
  return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
};
